<template>
  <div>
    <section class="page-content">
      <form action @submit.prevent="next">
        <article class="d-flex flex-column justify-content-center form-heading title-section form-section">
          <h1 class="font-weight-bold text-center w-75">BUSINESS PRACTICES</h1>
        </article>
        <article class="input-section form-section">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                Does your firm have written quality control procedures? <br>
              If yes, please include the table of contents with this application.
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="doesFirmHaveWrittenQuality"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="rcApplication.doesFirmHaveWrittenQuality"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="doesFirmHaveWrittenQuality"
                      value="false"
                      class="orep-radio"
                      @change="validateBeforeSubmit()"
                      v-model="rcApplication.doesFirmHaveWrittenQuality"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                v-show="errors.has('doesFirmHaveWrittenQuality')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('doesFirmHaveWrittenQuality') | filterText }}</span>
            </div>
          </div>

        </article>
        <article class="input-section form-section">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                Does your firm have an in-house continuing education program?
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="doesFirmHaveInHouseContinuing"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="rcApplication.doesFirmHaveInHouseContinuing"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="doesFirmHaveInHouseContinuing"
                      value="false"
                      class="orep-radio"
                      @change="validateBeforeSubmit()"
                      v-model="rcApplication.doesFirmHaveInHouseContinuing"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                v-show="errors.has('doesFirmHaveInHouseContinuing')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('doesFirmHaveInHouseContinuing') | filterText }}</span>
            </div>
          </div>
          <div class="col-md-12" v-if="rcApplication.doesFirmHaveInHouseContinuing == true || rcApplication.doesFirmHaveInHouseContinuing === 'true'">
            <label for class="orep-label">
              If yes, please describe:
            </label>
            <input
              type="text"
              placeholder="Please explain:"
              class="orep-text-input js-orep-input"
              v-if="rcApplication.doesFirmHaveInHouseContinuing == true || rcApplication.doesFirmHaveInHouseContinuing === 'true'"
              name="doesFirmHaveInHouseContinuingDetails"
              v-model="rcApplication.doesFirmHaveInHouseContinuingDetails"
            >
          </div>
        </article>
        <article class="input-section form-section">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                Do you have a written formal health and safety program in place?
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="doYouHaveWrittenFormalHealth"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="rcApplication.doYouHaveWrittenFormalHealth"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="doYouHaveWrittenFormalHealth"
                      value="false"
                      class="orep-radio"
                      @change="validateBeforeSubmit()"
                      v-model="rcApplication.doYouHaveWrittenFormalHealth"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                v-show="errors.has('doYouHaveWrittenFormalHealth')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('doYouHaveWrittenFormalHealth') | filterText }}</span>
            </div>
          </div>
        </article>
        <article class="input-section form-section">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                Do you engage in any operations, involving new installation of Exterior Insulation and Finishing Systems (EIFS)?
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="doYouEngageInAnyOperations"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="rcApplication.doYouEngageInAnyOperations"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="doYouEngageInAnyOperations"
                      value="false"
                      class="orep-radio"
                      @change="validateBeforeSubmit()"
                      v-model="rcApplication.doYouEngageInAnyOperations"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                v-show="errors.has('doYouEngageInAnyOperations')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('doYouEngageInAnyOperations') | filterText }}</span>
            </div>
          </div>
        </article>
        <article class="input-section form-section">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                Do you perform air quality testing prior to, during and after remediation? If yes, who performs the testing?
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="doYouPerformAirQualityTesting"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="rcApplication.doYouPerformAirQualityTesting"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="doYouPerformAirQualityTesting"
                      value="false"
                      class="orep-radio"
                      @change="validateBeforeSubmit()"
                      v-model="rcApplication.doYouPerformAirQualityTesting"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                v-show="errors.has('doYouPerformAirQualityTesting')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('doYouPerformAirQualityTesting') | filterText }}</span>
            </div>
          </div>
        </article>
        <article class="input-section form-section">
          <label for class="orep-label">
            What mold / fungus guidelines do you adhere to in the performance of abatement and/or assessments?
          </label>
          <input
            type="text"
            class="orep-text-input"
            name="whatMoldFungusGuidelinesAdhere"
            v-validate="'required'"
            @input="validateBeforeSubmit()"
            v-model="rcApplication.whatMoldFungusGuidelinesAdhere"
          >
          <span
            v-show="errors.has('whatMoldFungusGuidelinesAdhere')"
            class="help is-danger form-errors text-danger"
          >{{ errors.first('whatMoldFungusGuidelinesAdhere') | filterText }}</span>
        </article>
        <article class="input-section form-section">
          <label for class="orep-label">

            Do you provide written warranties for you work?          </label>
          <input
            type="text"
            class="orep-text-input"
            name="doYouProvideWrittenWarranties"
            v-validate="'required'"
            @input="validateBeforeSubmit()"
            v-model="rcApplication.doYouProvideWrittenWarranties"
          >
          <span
            v-show="errors.has('doYouProvideWrittenWarranties')"
            class="help is-danger form-errors text-danger"
          >{{ errors.first('doYouProvideWrittenWarranties') | filterText }}</span>
        </article>

        <article class="input-section form-section">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                Do you do new construction work not associated with fire & water restoration?
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="newConstructionWorkNotAssociatedWithFire"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="rcApplication.newConstructionWorkNotAssociatedWithFire"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="newConstructionWorkNotAssociatedWithFire"
                      value="false"
                      class="orep-radio"
                      @change="validateBeforeSubmit()"
                      v-model="rcApplication.newConstructionWorkNotAssociatedWithFire"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                v-show="errors.has('newConstructionWorkNotAssociatedWithFire')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('newConstructionWorkNotAssociatedWithFire') | filterText }}</span>
            </div>
          </div>
          <div class="col-md-12" v-if="rcApplication.newConstructionWorkNotAssociatedWithFire == true || rcApplication.newConstructionWorkNotAssociatedWithFire === 'true'">
            <label for class="orep-label">
              If so, what percentage of your annual gross revenues are associated with these operations:

            <input
              type="text"
              class="col-md-2 orep-text-input js-orep-input"
              v-if="rcApplication.newConstructionWorkNotAssociatedWithFire == true || rcApplication.newConstructionWorkNotAssociatedWithFire === 'true'"
              name="newConstructionWorkNotAssociatedWithFireDetails"
              v-model="rcApplication.newConstructionWorkNotAssociatedWithFireDetails"
            >%
            </label>
          </div>

        </article>
        <article class="input-section form-section">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                Do you do remodeling work not associated with fire & water restoration?
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="remodelingWorkNotAssociatedWithFire"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="rcApplication.remodelingWorkNotAssociatedWithFire"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="remodelingWorkNotAssociatedWithFire"
                      value="false"
                      class="orep-radio"
                      @change="validateBeforeSubmit()"
                      v-model="rcApplication.remodelingWorkNotAssociatedWithFire"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                v-show="errors.has('remodelingWorkNotAssociatedWithFire')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('remodelingWorkNotAssociatedWithFire') | filterText }}</span>
            </div>
          </div>
          <div class="col-md-12" v-if="rcApplication.remodelingWorkNotAssociatedWithFire == true || rcApplication.remodelingWorkNotAssociatedWithFire === 'true'">
            <label for class="orep-label">
              If so, what percentage of your annual gross revenues are associated with these operations:

              <input
                type="text"
                class="col-md-2 orep-text-input js-orep-input"
                v-if="rcApplication.remodelingWorkNotAssociatedWithFire == true || rcApplication.remodelingWorkNotAssociatedWithFire === 'true'"
                name="hasAnyMemberInvolvedInPropertyPreservationDetails"
                v-model="rcApplication.remodelingWorkNotAssociatedWithFireDetails"
              >%
            </label>
          </div>
        </article>
        <article class="input-section form-section">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                Do you do building of single-family homes, multi-family homes, or commercial buildings?
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="doBuildingOfSingleFamilyHomes"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="rcApplication.doBuildingOfSingleFamilyHomes"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="doBuildingOfSingleFamilyHomes"
                      value="false"
                      class="orep-radio"
                      @change="validateBeforeSubmit()"
                      v-model="rcApplication.doBuildingOfSingleFamilyHomes"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                v-show="errors.has('doBuildingOfSingleFamilyHomes')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('doBuildingOfSingleFamilyHomes') | filterText }}</span>
            </div>
          </div>
          <div class="col-md-12" v-if="rcApplication.doBuildingOfSingleFamilyHomes == true || rcApplication.doBuildingOfSingleFamilyHomes === 'true'">
            <label for class="orep-label">
              If so, how many of each per year: single family homes:
              <input
                type="text"
                class="col-md-2 orep-text-input js-orep-input"
                v-if="rcApplication.doBuildingOfSingleFamilyHomes == true || rcApplication.doBuildingOfSingleFamilyHomes === 'true'"
                name="singleFamilyHomes"
                v-model="rcApplication.singleFamilyHomes"
              >multi-family homes:
              <input
                type="text"
                class="col-md-2 orep-text-input js-orep-input"
                v-if="rcApplication.doBuildingOfSingleFamilyHomes == true || rcApplication.doBuildingOfSingleFamilyHomes === 'true'"
                name="hasAnyMemberInvolvedInPropertyPreservationDetails"
                v-model="rcApplication.multiFamilyHomes"
              >commercial blgs.:
              <input
                type="text"
                class="col-md-2 orep-text-input js-orep-input"
                v-if="rcApplication.doBuildingOfSingleFamilyHomes == true || rcApplication.doBuildingOfSingleFamilyHomes === 'true'"
                name="hasAnyMemberInvolvedInPropertyPreservationDetails"
                v-model="rcApplication.commericalBlgs"
              >
            </label>
          </div>

        </article>
        <article class="input-section form-section">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                Does any one project or contract represent more than 25% of your annual revenue?
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="projectMoreThan25PercentOfAnnual"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="rcApplication.projectMoreThan25PercentOfAnnual"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="projectMoreThan25PercentOfAnnual"
                      value="false"
                      class="orep-radio"
                      @change="validateBeforeSubmit()"
                      v-model="rcApplication.projectMoreThan25PercentOfAnnual"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                v-show="errors.has('projectMoreThan25PercentOfAnnual')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('projectMoreThan25PercentOfAnnual') | filterText }}</span>
            </div>
          </div>
          <div class="col-md-12" v-if="rcApplication.projectMoreThan25PercentOfAnnual == true || rcApplication.projectMoreThan25PercentOfAnnual === 'true'">
            <label for class="orep-label">
              If yes, please describe:
            </label>
            <input
              type="text"
              placeholder="Please explain:"
              class="orep-text-input js-orep-input"
              v-if="rcApplication.projectMoreThan25PercentOfAnnual == true || rcApplication.projectMoreThan25PercentOfAnnual === 'true'"
              name="projectMoreThan25PercentOfAnnualDetails"
              v-model="rcApplication.projectMoreThan25PercentOfAnnualDetails"
            >
          </div>
        </article>

        <article class="d-flex flex-column justify-content-center form-heading title-section form-section">
          <h1 class="font-weight-bold text-center w-75">Total number of staff</h1>
        </article>
        <article class="input-section form-section">
          <div class="row">
            <div class="col-md-6">
              <div class="radio">
                <label class="align-items-center w-100">
                  <label class="orep-label mb-0 mr-4 w-100">Architects or Engineers:</label>
                  <input
                    type="number"
                    name="numberOfStaffEngineers"
                    v-model="rcApplication.numberOfStaffEngineers"
                    class="orep-text-input ml-3 mr-1 w-100" 
                    @input="validateBeforeSubmit()"
                    style="width: 150px"
                  >
                </label>
              </div>
            </div>
            <div class="col-md-6">
              <div class="radio">
                <label class="align-items-center w-100">
                  <label class="orep-label mb-0 mr-4 w-100">Clerical and Accounting Employees:</label>
                  <input
                    type="number"
                    name="numberOfStaffAccounts"
                    v-model="rcApplication.numberOfStaffAccounts"
                    class="orep-text-input ml-3 mr-1 w-100"
                    @input="validateBeforeSubmit()"
                    style="width: 150px"
                  >
                </label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="radio ">
                <label class="align-items-center w-100">
                  <label class="orep-label mb-0 mr-4 w-100">Project Managers:</label>
                  <input
                    type="number"
                    name="numberOfStaffManagers"
                    v-model="rcApplication.numberOfStaffManagers"
                    class="orep-text-input ml-3 mr-1 w-100"
                    @input="validateBeforeSubmit()"
                    style="width: 150px"
                  >

                </label>
              </div>
            </div>
            <div class="col-md-6">
              <div class="radio ">
                <label class="align-items-center w-100">
                  <label class="orep-label mb-0 mr-4 w-100">Administrative Management:</label>
                  <input
                    type="number"
                    name="numberOfStaffAdmin"
                    v-model="rcApplication.numberOfStaffAdmin"
                    class="orep-text-input ml-3 mr-1 w-100"
                    @input="validateBeforeSubmit()"
                    style="width: 150px"
                  >
                </label>
              </div>
            </div>

          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="radio ">
                <label class="align-items-center w-100">
                  <label class="orep-label mb-0 mr-4 w-100">Field Personnel:</label>
                  <input
                    type="number"
                    name="numberOfStaffFieldPersonnel"
                    v-model="rcApplication.numberOfStaffFieldPersonnel"
                    class="orep-text-input ml-3 mr-1 w-100"
                    @input="validateBeforeSubmit()"
                    style="width: 150px"
                  >

                </label>
              </div>
            </div>
            <div class="col-md-6">
              <div class="radio ">
                <label class="align-items-center w-100">
                  <label class="orep-label mb-0 mr-4 w-100">Other:</label>
                  <input
                    type="number"
                    name="numberOfStaffFieldOther"
                    v-model="rcApplication.numberOfStaffFieldOther"
                    class="orep-text-input ml-3 mr-1 w-100"
                    @input="validateBeforeSubmit()"
                    style="width: 150px"
                  >
                </label>
              </div>
            </div>

          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="radio ">
                <label class="align-items-center w-100">
                  <label class="orep-label mb-0 mr-4 w-100">Other than the above:</label>
                  <input
                    type="number"
                    name="numberOfStaffFieldOtherThanAbove"
                    v-model="rcApplication.numberOfStaffFieldOtherThanAbove"
                    class="orep-text-input ml-3 mr-1 w-100"
                    @input="validateBeforeSubmit()"
                    style="width: 150px"
                  >

                </label>
              </div>
            </div>
            <div class="col-md-6">
              <div class="radio ">
                <label class="align-items-center w-100">
                  <label class="orep-label mb-0 mr-4 w-100">Number of Principals (included in listing above):</label>
                  <input
                    type="number"
                    name="numberOfStaffFieldPrincipals"
                    v-model="rcApplication.numberOfStaffFieldPrincipals"
                    class="orep-text-input ml-3 mr-1 w-100"
                    @input="validateBeforeSubmit()"
                    style="width: 150px"
                  >
                </label>
              </div>
            </div>

          </div>
        </article>

        <article class="d-flex flex-column justify-content-center form-heading title-section form-section">
          <h1 class="font-weight-bold text-center w-75">Subcontractors and Subconsultants</h1>
        </article>
        <article class="input-section form-section">
          <label for class="orep-label">
            Indicate the percentage of work subcontracted out to others:
            <input
              type="number"
              name="workSubcontractedPercent"
              v-model="rcApplication.workSubcontractedPercent"
              class="orep-text-input col-md-2 w-25"
              @input="validateBeforeSubmit()">% And percentage of work subcontracted out to 1099 employees:
            <input
              type="text"
              name="workSubcontractedOutTo1099"
              v-model="rcApplication.workSubcontractedOutTo1099"
              class="orep-text-input col-md-2 w-25"
              @input="validateBeforeSubmit()"> %
          </label>
        </article>
        <article class="input-section form-section">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                Require them to have General Liability insurance?
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="haveGeneralLiabilityInsurance"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="rcApplication.haveGeneralLiabilityInsurance"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="haveGeneralLiabilityInsurance"
                      value="false"
                      class="orep-radio"
                      @change="validateBeforeSubmit()"
                      v-model="rcApplication.haveGeneralLiabilityInsurance"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                v-show="errors.has('haveGeneralLiabilityInsurance')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('haveGeneralLiabilityInsurance') | filterText }}</span>
            </div>
          </div>
        </article>
        <article class="input-section form-section">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                Require them to have Contractors’ Pollution Liability, including coverage for Mold/Fungus?
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="haveContractorPollutionLiability"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="rcApplication.haveContractorPollutionLiability"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="haveContractorPollutionLiability"
                      value="false"
                      class="orep-radio"
                      @change="validateBeforeSubmit()"
                      v-model="rcApplication.haveContractorPollutionLiability"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                v-show="errors.has('haveContractorPollutionLiability')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('haveContractorPollutionLiability') | filterText }}</span>
            </div>
          </div>
        </article>
        <article class="input-section form-section">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                Allow subcontractors and/or subconsultants to work without providing you with a certificate of insurance?
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="workWithoutProvidingCertificate"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="rcApplication.workWithoutProvidingCertificate"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="workWithoutProvidingCertificate"
                      value="false"
                      class="orep-radio"
                      @change="validateBeforeSubmit()"
                      v-model="rcApplication.workWithoutProvidingCertificate"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                v-show="errors.has('workWithoutProvidingCertificate')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('workWithoutProvidingCertificate') | filterText }}</span>
            </div>
          </div>
        </article>
        <article class="input-section form-section">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                Require to be named as an Additional Insured on the subcontractors and/or subconsultants’ policies?
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="additionalInsuredOnTheSubcontractors"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="rcApplication.additionalInsuredOnTheSubcontractors"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="additionalInsuredOnTheSubcontractors"
                      value="false"
                      class="orep-radio"
                      @change="validateBeforeSubmit()"
                      v-model="rcApplication.additionalInsuredOnTheSubcontractors"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                v-show="errors.has('additionalInsuredOnTheSubcontractors')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('additionalInsuredOnTheSubcontractors') | filterText }}</span>
            </div>
          </div>
        </article>
        <article class="input-section form-section">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                Sign a contract and obtain Waivers of Subrogation and Hold Harmless Agreements?
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="signAContractAndObtainWaivers"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="rcApplication.signAContractAndObtainWaivers"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="signAContractAndObtainWaivers"
                      value="false"
                      class="orep-radio"
                      @change="validateBeforeSubmit()"
                      v-model="rcApplication.signAContractAndObtainWaivers"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                v-show="errors.has('signAContractAndObtainWaivers')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('signAContractAndObtainWaivers') | filterText }}</span>
            </div>
          </div>
        </article>
        <article class="input-section form-section">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                Verify all hired subcontractors and/or subconsultants carry their own Workers Compensation coverage?
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="verifyAllHiredSubContractors"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="rcApplication.verifyAllHiredSubContractors"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="verifyAllHiredSubContractors"
                      value="false"
                      class="orep-radio"
                      @change="validateBeforeSubmit()"
                      v-model="rcApplication.verifyAllHiredSubContractors"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                v-show="errors.has('verifyAllHiredSubContractors')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('verifyAllHiredSubContractors') | filterText }}</span>
            </div>
          </div>
        </article>
        <article class="d-flex flex-column justify-content-center form-heading title-section form-section">
          <h1 class="font-weight-bold text-center w-75">Geographical Extent</h1>
        </article>
        <article class="input-section form-section">
          <div class="table-scroll">
            <table width="100%">
              <thead>
              <tr>
                <th colspan="4">
                  List below all states within which you operate, the operations and/or services performed and the percentage of work performed in each state:              </th>
              </tr>
              <tr>
                <th>
                  State/Country
                </th>
                <th>
                  Operations and/or Services Performed
                </th>
                <th>
                  Percentage of work performed %
                </th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>
                  <input
                    type="text"
                    class="orep-text-input"
                    name="operatatedStateCountry1"
                    @input="validateBeforeSubmit()"
                    v-model="rcApplication.operatatedStateCountry1"
                  >
                </td>
                <td>
                  <input
                    type="text"
                    class="orep-text-input"
                    name="operationsAndServicePerformed1"
                    @input="validateBeforeSubmit()"
                    v-model="rcApplication.operationsAndServicePerformed1"
                  >
                </td>
                <td>
                  <input
                    type="text"
                    class="orep-text-input"
                    name="percentageOfWorkPerformed1"
                    @input="validateBeforeSubmit()"
                    v-model="rcApplication.percentageOfWorkPerformed1"
                  >
                </td>
              </tr>
              <tr>
                <td>
                  <input
                    type="text"
                    class="orep-text-input"
                    name="operatatedStateCountry2"
                    @input="validateBeforeSubmit()"
                    v-model="rcApplication.operatatedStateCountry2"
                  >
                </td>
                <td>
                  <input
                    type="text"
                    class="orep-text-input"
                    name="operationsAndServicePerformed2"
                    @input="validateBeforeSubmit()"
                    v-model="rcApplication.operationsAndServicePerformed2"
                  >
                </td>
                <td>
                  <input
                    type="text"
                    class="orep-text-input"
                    name="percentageOfWorkPerformed2"
                    @input="validateBeforeSubmit()"
                    v-model="rcApplication.percentageOfWorkPerformed2"
                  >
                </td>
              </tr>
              <tr>
                <td>
                  <input
                    type="text"
                    class="orep-text-input"
                    name="operatatedStateCountry3"
                    @input="validateBeforeSubmit()"
                    v-model="rcApplication.operatatedStateCountry3"
                  >
                </td>
                <td>
                  <input
                    type="text"
                    class="orep-text-input"
                    name="operationsAndServicePerformed3"
                    @input="validateBeforeSubmit()"
                    v-model="rcApplication.operationsAndServicePerformed3"
                  >
                </td>
                <td>
                  <input
                    type="text"
                    class="orep-text-input"
                    name="percentageOfWorkPerformed3"
                    @input="validateBeforeSubmit()"
                    v-model="rcApplication.percentageOfWorkPerformed3"
                  >
                </td>
              </tr>
              </tbody>
            </table>
          </div>          
        </article>

        <article class="input-section form-section">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                Does the applicant perform operations / services in the state of New York?
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="applicantPerformOperationsInNewYork"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="rcApplication.applicantPerformOperationsInNewYork"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="applicantPerformOperationsInNewYork"
                      value="false"
                      class="orep-radio"
                      @change="validateBeforeSubmit()"
                      v-model="rcApplication.applicantPerformOperationsInNewYork"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                v-show="errors.has('applicantPerformOperationsInNewYork')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('applicantPerformOperationsInNewYork') | filterText }}</span>
            </div>
          </div>
          <div class="col-md-12" v-if="rcApplication.applicantPerformOperationsInNewYork == true || rcApplication.applicantPerformOperationsInNewYork === 'true'">
            <label for class="orep-label">
              f yes, what percentage is performed in the 5 boroughs (Bronx, Manhattan, Brooklyn, Queens, and Staten Island), the Metropolitan region, or the counties of Nassau, Suffolk, Rockland, and Westchester?

            <input
              type="text"
              class="col-md-2 orep-text-input js-orep-input"
              v-if="rcApplication.applicantPerformOperationsInNewYork == true || rcApplication.applicantPerformOperationsInNewYork === 'true'"
              name="applicantPerformOperationsInNewYorkDetails"
              v-model="rcApplication.applicantPerformOperationsInNewYorkDetails"
            > %
            </label>
          </div>
        </article>

        <article class="input-section form-section">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                Do you engage in any work outside of the U.S.?
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="engageInAnyWorkOutsideUs"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="rcApplication.engageInAnyWorkOutsideUs"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="engageInAnyWorkOutsideUs"
                      value="false"
                      class="orep-radio"
                      @change="validateBeforeSubmit()"
                      v-model="rcApplication.engageInAnyWorkOutsideUs"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                v-show="errors.has('engageInAnyWorkOutsideUs')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('engageInAnyWorkOutsideUs') | filterText }}</span>
            </div>
          </div>
          <div class="col-md-12" v-if="rcApplication.engageInAnyWorkOutsideUs == true || rcApplication.engageInAnyWorkOutsideUs === 'true'">
            <label for class="orep-label">
              If yes, what percentage?
              <input
                type="text"
                class="col-md-2 orep-text-input js-orep-input"
                v-if="rcApplication.engageInAnyWorkOutsideUs == true || rcApplication.engageInAnyWorkOutsideUs === 'true'"
                name="hasAnyMemberInvolvedInPropertyPreservationDetails"
                v-model="rcApplication.engageInAnyWorkOutsideUsDetails"
              > %
            </label>
          </div>
        </article>

        <article class="d-flex flex-column justify-content-center form-heading title-section form-section">
          <h1 class="font-weight-bold text-center w-75">Type of Clients</h1>
        </article>
        <article class="input-section form-section">
          <div class="table-scroll">
            <table width="100%">
              <thead>
              <tr>
                <th colspan="4">
                  Please indicate the approximate percentage of your total gross revenues derived from the following categories of clients:
                </th>
              </tr>
              <tr>
                <th>
                  Category
                </th>
                <th>
                  Percent
                </th>
                <th>
                  Category
                </th>
                <th>
                  Percent
                </th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>
                  Insurance Carriers, from work related to fire/water restoration including F&W build-back work
                </td>
                <td>
                  <input
                    type="number"
                    class="orep-text-input"
                    name="insuranceCarriersPercent"
                    v-validate="'decimal'"
                    placeholder="0"
                    @input="validateBeforeSubmit()"
                    v-model="insuranceCarriersPercent"
                  >
                  <span
                    v-show="errors.has('insuranceCarriersPercent')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('insuranceCarriersPercent') | filterText }}</span>
                </td>
                <td>
                  Contractors
                </td>
                <td>
                  <input
                    type="number"
                    class="orep-text-input"
                    name="insuranceCarriersContractors"
                    v-validate="'decimal'"
                    placeholder="0"
                    @input="validateBeforeSubmit()"
                    v-model="insuranceCarriersContractors"
                  >
                  <span
                    v-show="errors.has('insuranceCarriersContractors')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('insuranceCarriersContractors') | filterText }}</span>
                </td>
              </tr>
              <tr>
                <td>
                  Direct Repair Networks, from work related to fire/water restoration including F&W build-back work
                </td>
                <td>
                  <input
                    type="number"
                    class="orep-text-input"
                    name="directRepairNetworksPercent"
                    v-validate="'decimal'"
                    placeholder="0"
                    @input="validateBeforeSubmit()"
                    v-model="directRepairNetworksPercent"
                  >
                  <span
                    v-show="errors.has('directRepairNetworksPercent')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('directRepairNetworksPercent') | filterText }}</span>
                </td>
                <td>
                  Owners who act as their own contractors
                </td>
                <td>
                  <input
                    type="number"
                    class="orep-text-input"
                    name="directRepairNetworksCategory"
                    v-validate="'decimal'"
                    placeholder="0"
                    @input="validateBeforeSubmit()"
                    v-model="directRepairNetworksCategory"
                  >
                  <span
                    v-show="errors.has('directRepairNetworksCategory')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('directRepairNetworksCategory') | filterText }}</span>
                </td>
              </tr>
              <tr>
                <td>
                  State or Local government
                </td>
                <td>
                  <input
                    type="number"
                    class="orep-text-input"
                    name="stateOrLocalGovtPercent"
                    v-validate="'decimal'"
                    placeholder="0"
                    @input="validateBeforeSubmit()"
                    v-model="stateOrLocalGovtPercent"
                  >
                  <span
                    v-show="errors.has('stateOrLocalGovtPercent')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('stateOrLocalGovtPercent') | filterText }}</span>
                </td>
                <td>
                  Other (explain):
                </td>
                <td>
                  <input
                    type="number"
                    class="orep-text-input"
                    name="stateOrLocalGovtCategory"
                    v-validate="'decimal'"
                    placeholder="0"
                    @input="validateBeforeSubmit()"
                    v-model="stateOrLocalGovtCategory"
                  >
                  <span
                    v-show="errors.has('stateOrLocalGovtCategory')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('stateOrLocalGovtCategory') | filterText }}</span>
                </td>
              </tr>
              </tbody>
            </table>
          </div>          
        </article>

        <article class="d-flex flex-column justify-content-center form-heading title-section form-section">
          <h1 class="font-weight-bold text-center w-75">Type of Projects</h1>
        </article>
        <article class="input-section form-section">
          <div class="table-scroll">
            <table width="100%">
              <thead>
              <tr>
                <th colspan="4">
                  Please indicate the approximate percentage of your total gross revenues derived from the following types of projects:
                </th>
              </tr>
              <tr>
                <th>
                  Category
                </th>
                <th>
                  Percent
                </th>
                <th>
                  Category
                </th>
                <th>
                  Percent
                </th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>
                  Residential – Multifamily
                </td>
                <td>
                  <input
                    type="number"
                    class="orep-text-input"
                    name="typeOfProjectResidential"
                    v-validate="'decimal'"
                    placeholder="0"
                    @input="validateBeforeSubmit()"
                    v-model="typeOfProjectResidential"
                  >
                  <span
                    v-show="errors.has('typeOfProjectResidential')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('typeOfProjectResidential') | filterText }}</span>
                </td>
                <td>
                  Retail / Shopping Centers
                </td>
                <td>
                  <input
                    type="number"
                    class="orep-text-input"
                    name="typeOfProjectRetail"
                    v-validate="'decimal'"
                    placeholder="0"
                    @input="validateBeforeSubmit()"
                    v-model="typeOfProjectRetail"
                  >
                  <span
                    v-show="errors.has('typeOfProjectRetail')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('typeOfProjectRetail') | filterText }}</span>
                </td>
              </tr>
              <tr>
                <td>
                  Office / Commercial buildings
                </td>
                <td>
                  <input
                    type="number"
                    class="orep-text-input"
                    name="typeOfProjectOffice"
                    v-validate="'decimal'"
                    placeholder="0"
                    @input="validateBeforeSubmit()"
                    v-model="typeOfProjectOffice"
                  >
                  <span
                    v-show="errors.has('typeOfProjectOffice')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('typeOfProjectOffice') | filterText }}</span>
                </td>
                <td>
                  Hotels / Hospitality
                </td>
                <td>
                  <input
                    type="number"
                    class="orep-text-input"
                    name="typeOfProjectHotels"
                    v-validate="'decimal'"
                    placeholder="0"
                    @input="validateBeforeSubmit()"
                    v-model="typeOfProjectHotels"
                  >
                  <span
                    v-show="errors.has('typeOfProjectHotels')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('typeOfProjectHotels') | filterText }}</span>
                </td>
              </tr>
              <tr>
                <td>
                  State or Local government
                </td>
                <td>
                  <input
                    type="number"
                    class="orep-text-input"
                    name="typeOfProjectState"
                    v-validate="'decimal'"
                    placeholder="0"
                    @input="validateBeforeSubmit()"
                    v-model="typeOfProjectState"
                  >
                  <span
                    v-show="errors.has('typeOfProjectState')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('typeOfProjectState') | filterText }}</span>
                </td>
                <td>
                  Other (explain):
                </td>
                <td>
                  <input
                    type="number"
                    class="orep-text-input"
                    name="typeOfProjectOther"
                    v-validate="'decimal'"
                    placeholder="0"
                    @input="validateBeforeSubmit()"
                    v-model="typeOfProjectOther"
                  >
                  <span
                    v-show="errors.has('typeOfProjectOther')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('typeOfProjectOther') | filterText }}</span>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
         
        </article>
      </form>
    </section>
    <div>
      <div class="row">
        <div class="col-md-12">
          <section class="flex wrap bottom-section">
            <router-link :to="{name:'rc-application-2'}" class="next-btn back-btn flex mont spaced">
              <i class="fas fa-arrow-left"></i>
              Back
            </router-link>
            <article class="orep-pagination">
              <button class="pagination-dots" @click="navigateToOne()"></button>
              <button class="pagination-dots" @click="prev()"></button>
              <span class="pagination-dots pagination-current"></span>
              <button class="pagination-dots" @click="navigateToNext('rc-application-4')" :disabled="!state.pageThreeIsValid"></button>
              <button class="pagination-dots" @click="navigateToNext('rc-application-5')" :disabled="!state.pageThreeIsValid || !state.pageFourIsValid"></button>
              <button
                class="pagination-dots"
                @click="navigateToNext('rc-application-6')"
                :disabled="!state.pageThreeIsValid || !state.pageFourIsValid || !state.pageFiveIsValid">
              </button>
            </article>
            <button
              type="submit"
              :disabled="!state.pageThreeIsValid"
              :class="{submitDisabled: !state.pageThreeIsValid}"
              class="next-btn mont spaced pull-right"
              @click="navigateToNext('rc-application-4')"
            >Next</button>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import Datepicker from 'vuejs-datepicker';

export default {
  name: "rc-application-3",
  computed: {
    rcApplication() {
      return this.$store.state.rcApplication.rcApplication;
    },
    state() {
      return this.$store.state.rcApplication;
    },
    errorMsg() {
      return this.$store.state.rcApplication.errorMsg;
    },
    insuranceCarriersPercent: {
      get: function() {
        return this.rcApplication.insuranceCarriersPercent || '';
      },
      set: function(val) {
        this.rcApplication.insuranceCarriersPercent = val;
      }
    },
    insuranceCarriersContractors: {
      get: function() {
        return this.rcApplication.insuranceCarriersContractors || '';
      },
      set: function(val) {
        this.rcApplication.insuranceCarriersContractors = val;
      }
    },
    directRepairNetworksPercent: {
      get: function() {
        return this.rcApplication.directRepairNetworksPercent || '';
      },
      set: function(val) {
        this.rcApplication.directRepairNetworksPercent = val;
      }
    },
    directRepairNetworksCategory: {
      get: function() {
        return this.rcApplication.directRepairNetworksCategory || '';
      },
      set: function(val) {
        this.rcApplication.directRepairNetworksCategory = val;
      }
    },
    stateOrLocalGovtPercent: {
      get: function() {
        return this.rcApplication.stateOrLocalGovtPercent || '';
      },
      set: function(val) {
        this.rcApplication.stateOrLocalGovtPercent = val;
      }
    },
    stateOrLocalGovtCategory: {
      get: function() {
        return this.rcApplication.stateOrLocalGovtCategory || '';
      },
      set: function(val) {
        this.rcApplication.stateOrLocalGovtCategory = val;
      }
    },
    typeOfProjectResidential: {
      get: function() {
        return this.rcApplication.typeOfProjectResidential || '';
      },
      set: function(val) {
        this.rcApplication.typeOfProjectResidential = val;
      }
    },
    typeOfProjectRetail: {
      get: function() {
        return this.rcApplication.typeOfProjectRetail || '';
      },
      set: function(val) {
        this.rcApplication.typeOfProjectRetail = val;
      }
    },
    typeOfProjectOffice: {
      get: function() {
        return this.rcApplication.typeOfProjectOffice || '';
      },
      set: function(val) {
        this.rcApplication.typeOfProjectOffice = val;
      }
    },
    typeOfProjectHotels: {
      get: function() {
        return this.rcApplication.typeOfProjectHotels || '';
      },
      set: function(val) {
        this.rcApplication.typeOfProjectHotels = val;
      }
    },
    typeOfProjectState: {
      get: function() {
        return this.rcApplication.typeOfProjectState || '';
      },
      set: function(val) {
        this.rcApplication.typeOfProjectState = val;
      }
    },
    typeOfProjectOther: {
      get: function() {
        return this.rcApplication.typeOfProjectOther || '';
      },
      set: function(val) {
        this.rcApplication.typeOfProjectOther = val;
      }
    },
  },
  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.$notify({
            group: 'error',
            type: 'error',
            title: 'Error',
            text: this.errorMsg
          });
        }
      }
    }
  },
  methods: {
    desiredCoverage(event) {
      if(!this.rcApplication.limitOfCoverages.find(coverage => coverage === event.target.value)) {
        if (this.rcApplication.limitOfCoverages.length < 2) {
          this.rcApplication.limitOfCoverages.push(event.target.value);
        } else {
          this.$notify({
            group: 'error',
            type: 'warning',
            title: 'Warning',
            text: 'You can select up to 2 coverages.'
          });
        }
      } else {
        this.rcApplication.limitOfCoverages = this.rcApplication.limitOfCoverages.filter(coverage => coverage !== event.target.value);
      }
    },

    navigateToNext(routeName) {
      this.$router.push({
        name: routeName
      });
    },

    prev() {
      this.$router.push({
        name: "rc-application-2"
      });
    },

    navigateToOne() {
      this.$router.push({
        name: "rc-application-1"
      });
    },

    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageThreeIsValid = true;
          return;
        }
        this.state.pageThreeIsValid = false;
      });
    },
    validateBeforeSubmitCheck(e){
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.state.rcApplication.realEstateAgentBroker === true){
            this.state.pageTwoIsValid = true;
          }
          else {
            this.state.pageTwoIsValid = false;
            this.validateBeforeSubmit();
          }
          return;
        }
        this.state.pageTwoIsValid = true;

      });
    },
  },

  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf("req") !== -1) {
          return "This field is required";
        } else {
          return x.replace("_", " ");
        }
      }
    }
  },

  mounted() {
    $('html, body').animate({
        scrollTop: $('.page-content').offset().top
    }, 500);
  },
  components: {
    Datepicker
  }
};
</script>

<style scoped>
table td, table th {
  border: 1px solid black;
}
table th {
  height: 35px;
}
table td:not(:first-child), table th:not(:first-child) {
  text-align: center;
  max-width: 140px;
}
table input {
  width: 100%;
  text-align: center;
}
</style>

